import { createStoreModuleGroupInjector, createStoreModuleInjector } from 'dtg-shared/store/injectors';

import { CollectionsModule, FileModule, RootModule } from './create';
import { getCollection, getFileModule, getModule } from './service';

export const injectCollection = createStoreModuleInjector<CollectionsModule>(getCollection);
export const injectCollectionGroup = createStoreModuleGroupInjector<CollectionsModule>(getCollection);
export const injectFileModule = createStoreModuleInjector<FileModule>(getFileModule);
export const injectModule = createStoreModuleInjector<RootModule>(getModule);
